export const CONTENT_PAG = {
    PAG_CONF: "pagina_confirmacion",
    PAG_EDIT: "pagina_edicion",
    PAG_VERI: "pagina_verificacion",
    PAG_VERC: "pagina_verificacion_codigo",
    PAG_ERRO: "pagina_error"
};

export const LAYOUT_PAG ={
    PAG_MEN: "pagina_infoDevMensaje",
    PAG_LAY: "pagina_infoDevLayout",
    PAG_EXI: "pagina_infoDevRegExi"
}